import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideToastr } from 'ngx-toastr';

import { AithToastComponent } from './aith-toast.component';
import { JonasToastOutlet } from './jonas-toast-outlet';
import { TOAST_OUTLET } from './toast-outlet';

/**
 * Production toast wiring (T037, R-008 spike): ToastrService is providedIn
 * root; provideToastr supplies the house global config; JonasToastOutlet is
 * the TOAST_OUTLET adapter. Kept OUT of the per-test TestBed surface — specs
 * substitute a recording TOAST_OUTLET fake instead.
 *
 * toastComponent is the house AithToastComponent: the library default
 * hard-codes role="alert" on every message, while the contract requires
 * role="status"/polite for info/success/warning — the payload carries the
 * facade-computed semantics through.
 */
export function provideAithNotifications(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideToastr({
      positionClass: 'toast-top-right',
      newestOnTop: true,
      maxOpened: 3,
      preventDuplicates: false,
      toastComponent: AithToastComponent,
    }),
    { provide: TOAST_OUTLET, useClass: JonasToastOutlet },
  ]);
}
